/* NW sengeguide: lagerstyret tilgaengelighed for lagner. Tilfoejet 31-08-2026.

   FEJLEN: LAGEN_AVAIL i nw-sg-8.js er en HAANDSKREVET tabel over hvilke
   stoerrelser der findes pr. farve. Den slaas op paa farvens PLADS i
   lagenColors, ikke paa produktet. To ting gaar galt:

   1) Tabellen har otte poster, altsaa bambusfarverne. nw-sg-tilvalg.js skifter
      lagenColors ud efter materiale, men indeksene bliver staaende. Paa et
      egyptisk saet arvede Sand (plads 1) derfor bambus Lys beiges liste, som
      kun rummer 90x200. Sand 180x200 stod graa med 216 stk. paa lager.

   2) En haandskrevet lagertabel kan aldrig blive rigtig. Maalt 31-08-2026 lover
      den bambus boxlagen i 180x200 for Lys beige, Taupe og Khaki, hvor der kun
      findes 90x200, og den spaerrer Taupe kuvertlagen 180x200 som ER paa lager.
      Over-lovningen er den farlige: guiden tilbyder en stoerrelse der ikke kan
      leveres, og varen falder tavst ud af kurven.

   LOESNINGEN: hent det faktiske sortiment fra /products/<handle>.js og byg
   tabellen derfra. Samme princip som nw-sg-priser.js bruger til priserne, og
   samme laere som pristabellen: en faelles tabel pr. materiale kan ikke holdes
   rigtig i haanden.

   Filen overskriver window.lagenHas. Den spaerrer ALDRIG paa gaet: er data ikke
   hentet endnu, eller kunne et produkt ikke hentes, svarer den ja. Hellere vise
   en stoerrelse et oejeblik for meget end at skjule noget der er paa lager. */
(function(){
  'use strict';

  var cache = {};        /* handle -> array af stoerrelser, eller null ved fejl */
  var henter = {};
  var tabel = null;      /* { box: {ci: [str]}, kuvert: {ci: [str]} } */
  var tabelMat = null;
  var planlagt = false;

  /* "90x200x35cm / Beige" og "90×200" skal begge blive til "90x200". */
  function norm(s){
    var m = String(s == null ? '' : s).replace(/×/g, 'x').match(/(\d+)\s*x\s*(\d+)/);
    return m ? (m[1] + 'x' + m[2]) : '';
  }

  function mat(){
    try{
      if(typeof chosen === 'undefined' || !chosen || !chosen.mat){ return null; }
      return chosen.mat;
    }catch(e){ return null; }
  }

  function hent(handle){
    if(!handle || cache[handle] !== undefined || henter[handle]){ return; }
    henter[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        var str = [];
        if(p && p.variants){
          p.variants.forEach(function(v){
            if(!v || !v.available){ return; }
            var n = norm(v.title);
            if(!n && v.options && v.options.length){ n = norm(v.options[0]); }
            if(n && str.indexOf(n) < 0){ str.push(n); }
          });
          cache[handle] = str;
        }else{
          cache[handle] = null;
        }
        plan();
      })
      .catch(function(){ cache[handle] = null; plan(); });
  }

  function byg(){
    var m = mat();
    if(!m || !window.nwSgTilvalg){ return; }
    var ny = { box: {}, kuvert: {} };
    ['box', 'kuvert'].forEach(function(t){
      var handles;
      try{ handles = window.nwSgTilvalg.lagenHandles(m, t); }catch(e){ handles = null; }
      if(!handles || !handles.length){ return; }
      handles.forEach(function(h, i){
        if(cache[h] === undefined){ hent(h); return; }
        if(cache[h] === null){ return; }   /* kunne ikke hentes: spaer ikke paa gaet */
        ny[t][i] = cache[h];
      });
    });
    tabel = ny;
    tabelMat = m;
  }

  function gentegn(){
    try{
      if(document.getElementById('addons') && typeof window.renderSet === 'function'){
        window.renderSet();
      }
    }catch(e){}
  }

  /* Bygger paa naeste tick og gentegner KUN hvis tabellen faktisk aendrede sig.
     Uden den vagt ville gentegningen udloese observeren og loebe i ring. */
  function plan(){
    if(planlagt){ return; }
    planlagt = true;
    setTimeout(function(){
      planlagt = false;
      var foer = tabelMat + '|' + JSON.stringify(tabel);
      byg();
      if((tabelMat + '|' + JSON.stringify(tabel)) !== foer){ gentegn(); }
    }, 0);
  }

  /* Erstatter opslaget i nw-sg-8.js. Samme signatur, men paa rigtige data. */
  window.lagenHas = function(ci, type, size){
    try{
      var m = mat();
      if(!tabel || tabelMat !== m){ plan(); return true; }
      var t = (type === 'kuvert') ? 'kuvert' : 'box';
      var liste = tabel[t] ? tabel[t][ci] : null;
      if(!liste){ return true; }          /* ukendt farve: spaer ikke */
      var s = norm(size);
      if(!s){ return true; }
      for(var i = 0; i < liste.length; i++){
        if(liste[i] === s){ return true; }
      }
      return false;
    }catch(e){ return true; }
  };

  /* Materialet skiftes i renderResult. Kunden skifter type og farve via
     refresh(), som gentegner #addons udenom renderResult, saa der skal
     lyttes begge steder. Se samme faelde i nw-sg-tekst.js og nw-sg-priser.js. */
  var hooket = false;
  function hook(){
    if(hooket || typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    var f = window.renderResult;
    window.renderResult = function(){
      var r = f.apply(this, arguments);
      plan();
      return r;
    };
  }

  var observeret = false;
  function observer(){
    if(observeret){ return; }
    var box = document.getElementById('addons');
    if(!box){ return; }
    observeret = true;
    try{
      new MutationObserver(function(){ plan(); }).observe(box, { childList: true, subtree: true });
    }catch(e){}
  }

  function start(){ hook(); observer(); plan(); }

  start();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  window.addEventListener('load', start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();